import React from 'react';
import CurrencyFormat from 'react-number-format';
import { Col, Row } from 'reactstrap';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import Modal from '../../../components/modal/Modal';
import { useDict } from '../../../contexts/LanguageContext';
import { dateFormatter } from '../../../utils/dateHelper';
import CommentBoard from '../../investNow/views/CommentBoard';

const InvestmentNoteDetailsModal = (props) => {
    const { isOpen, toggle, investmentNoteDetails, onDownloadInvestmentMemo } = props;

    const dict = useDict();

    const { data: profileData } = useProfileQuery();

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            title={dict.review}
            headerType="review"
            cancelText={dict.close}
            onCancel={toggle}
            size="lg"
        >
            <div className="modal__body px-3 color-text font-weight-bold" style={{ textAlign: 'left' }}>
                <Row className="mb-2 pt-2">
                    <Col xs={6}>{dict.investmentNote}:</Col>
                    <Col xs={6} className="text-right">
                        {investmentNoteDetails?.name}
                    </Col>
                </Row>

                {investmentNoteDetails?.issuer_name && (
                    <Row className="mb-2">
                        <Col xs={6}>{dict.issuer}:</Col>
                        <Col xs={6} className="text-right">
                            {investmentNoteDetails?.issuer_name}
                        </Col>
                    </Row>
                )}

                <Row className="mb-2">
                    <Col xs={6}>{dict.issueAmount}:</Col>
                    <Col xs={6} className="text-right">
                        <CurrencyFormat
                            value={investmentNoteDetails?.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                            decimalScale={2}
                            fixedDecimalScale
                        />
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={6}>{dict.issueDate}:</Col>
                    <Col xs={6} className="text-right">
                        {dateFormatter(investmentNoteDetails?.launch_date)}
                    </Col>
                </Row>
                {
                    profileData?.is_kyc_verified && (
                        <CommentBoard
                            investmentNoteId={investmentNoteDetails?.id}
                        />
                    )
                }
            </div>
        </Modal>
    );
};

export default InvestmentNoteDetailsModal;
